interface App {
  Root: string;
  AppDsgvo: string;
  AppImprint: string;
  Export: string;
  Wrangler: string;
  Data: string;
  List: string;
  OldList: string;
  Overview: string;
  Piechart: string;
  Sparklines: string;
  Barchart: string;
  Sunburst: string;
  Timeline: string;
  Treemap: string;
  Sankey: string;
  ContactGraph: string;
  LocationHistory: string;
  [key: string]: string; // Add index signature
}

const appRoutes: App = {
  Root: "",
  AppDsgvo: "/dsgvo",
  AppImprint: "/imprint",
  Export: "/export",
  Wrangler: "/wrangler/:archiveId",
  Data: "/data/:providerId",
  List: "/list",
  OldList: "/oldlist",
  Overview: "/overview",
  Piechart: "/piechart",
  Sankey: "/sankey",
  Sparklines: "/sparklines",
  Barchart: "/barchart",
  Sunburst: "/sunburst",
  Timeline: "/timeline",
  Treemap: "/treemap",
  ContactGraph: "/contactgraph",
  LocationHistory: "/location-history",
};

export default {
  About: "/about",
  Debug: "/debug",
  Dsgvo: "/dsgvo",
  Imprint: "/imprint",
  Root: "/",
  Application: "/app",
  App: appRoutes,
  VisualizationOrder: [
    "Treemap",
    "Timeline",
    "Sunburst",
    "Sparklines",
    "Sankey",
    "Piechart",
    "ContactGraph",
    "Barchart",
    "List",
  ],
};
